// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	EstateGallery: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "EstateGallery" */
				'./index'
			),
	} ),
};
